<template>
  <div>
    <b-row class="title-row">
      <b-col class="var-height" v-on:click="onClick" cols="10">
        <div class="dot clickable">WIGR</div>
        <div class="title-wrapper">
          <h1 class="title-text clickable">WhenIsGameReleased.com</h1>
          <h2 class="tagline clickable">Your go to web calendar for video game releases</h2>
        </div>
      </b-col>
      <b-col v-if="this.showCalendarToggle" class="var-height" cols="2">
        <div class="centered clickable-icon squared" v-on:click="this.clicked">
          <i :class="this.toggled ? 'fa fa-calendar' : 'fa fa-clone'" aria-hidden="true"></i>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'custom-logo',
  props: ['onClick'],
  data () {
    return {
      showCalendarToggle: false,
      toggled: false
    }
  },
  methods: {
    clicked () {
      this.toggled = !this.toggled
      this.$store.dispatch('toggleCalendar')
    },
    checkIsPhone () {
      const Mobile = window.matchMedia('only screen and (max-width: 450px)')
      return Mobile.matches
    }
  },
  mounted () {
    if (this.checkIsPhone()) {
      this.showCalendarToggle = true
    }
  }
}
</script>

<style>
.centered {
  line-height: 3.3rem;
}

.title-row {
  margin-top: 15px;
}

.title-wrapper {
  text-align: left;
  margin-left: 10px;
}

.title-text {
  font-family: Viga;
  padding: 0px;
  margin: 0px;
  font-size: 2rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tagline {
  font-family: Viga;
  padding: 0px;
  margin: 0px;
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.clickable {
  cursor: pointer;
}

.clickable-icon {
  cursor: pointer;
  color: #CFD0D1;
  background-color: #222222;
  border-radius: 50%;
}

.dot {
  height: 60px;
  width: 60px;
  margin-right: 10px;
  background-color: #ff5555;
  border-radius: 50%;
  font-family: Viga;
  font-weight: 700;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  line-height: 60px;
  float: left;
}

@media (max-width: 379px) {
  .dot {
    height: 25px;
    width: 25px;
    font-size: 0.4rem;
    line-height: 25px;
  }

  .title-text {
    font-size: 0.8rem;
  }
  .tagline {
    font-size: 0.4rem;
  }

  .var-height {
    height: 25px;
  }

  .centered {
    line-height: 25px;
  }
}

@media (max-width: 456px) and (min-width: 380px) {
  .dot {
    height: 35px;
    width: 35px;
    font-size: 0.6rem;
    line-height: 35px;
  }

  .title-text {
    font-size: 1.2rem;
  }
  .tagline {
    font-size: 0.6rem;
  }

  .centered {
    line-height: 35px;
  }
}

@media (max-width: 570px) and (min-width: 457px) {
  .dot {
    height: 45px;
    width: 45px;
    font-size: 0.8rem;
    line-height: 45px;
  }

  .title-text {
    font-size: 1.4rem;
  }
  .tagline {
    font-size: 0.7rem;
  }
}

@media (max-width: 767px) and (min-width: 571px) {
  .dot {
    height: 48px;
    width: 48px;
    font-size: 1rem;
    line-height: 48px;
  }

  .title-text {
    font-size: 1.5rem;
  }
  .tagline {
    font-size: 0.8rem;
  }
}

@media (max-width: 991px) and (min-width: 768px) {
  .dot {
    height: 48px;
    width: 48px;
    font-size: 1rem;
    line-height: 48px;
  }

  .title-text {
    font-size: 1.5rem;
  }
  .tagline {
    font-size: 0.8rem;
  }
}
</style>
